import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';

export class CtrBodyToSimpleSapElementMapper
    extends BaseElementToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const type = this.formatType('SKP', 6, 1);
        const color = this.toColor(element);
        return [SimpleSapElement.ELEMENT(type, color)];
    }
}
